// eslint-disable-next-line no-shadow
export enum DataHooks {
  RescheduledBookingDetails = 'rescheduled-booking-details',
  Button = 'rescheduled-booking-details-button',
}
